@if (hasError()) {
  <mat-card appearance='outlined' class='errorcard'>
    <mat-card-header>
      <div mat-card-avatar>
        <mat-icon>error_outline</mat-icon>
      </div>
      <mat-card-title>{{ 'SEARCH.ERRORTEXT' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ error }}</mat-card-subtitle>
    </mat-card-header>
  </mat-card>
}
@if (isNotFound) {
  <mat-card appearance='outlined' class='notfoundcard'>
    <mat-card-header>
      <div mat-card-avatar>
        <mat-icon>info</mat-icon>
      </div>
      <mat-card-title>{{ 'SEARCH.NOTFOUNDTEXT' | translate }}</mat-card-title>
    </mat-card-header>
  </mat-card>
}

@if (searchEnabled) {
  <mat-card appearance='outlined' class='searchcard'>
    <mat-card-content>
      <ldw-search
        [definition]='searchDefinition'
        (formSubmit)='submitForm($event)'
        (formClear)='clearForm($event)'
        (scanSelected)='scan($event)'
      ></ldw-search>
    </mat-card-content>
  </mat-card>
}
@if (!searchEnabled) {
  <mat-card appearance='outlined' class='searchInfo' (click)='reopenSearch()'>
    <mat-card-header class='search-header'>
      <div mat-card-avatar>
        @if (!searchMetadata) {
          <mat-icon matTooltip="{{ showToolTip()? ('SEARCH.DEFAULTSEARCH' | translate):'' }}"> search </mat-icon>
        }
        @if (searchMetadata) {
          <mat-icon matTooltip="{{ showToolTip() ? ('SEARCH.SEARCHWITHMETADATA' | translate) : '' }}"> manage_search </mat-icon>
        }
      </div>
      <mat-card-title class='search-title'>{{ searchHeaderText }}</mat-card-title>
    </mat-card-header>
  </mat-card>
}

@if (hasData) {
  <div class='detailcontent'>
    <ldw-split-view [useSplitMode]='useSplitMode' [hasDetail]='hasDetail'>
      <div class='split-view-content-list'>
        <ldw-structure-list-view
          [data]='searchResult'
          [search]='searchText'
          [showTreePath]='true'
          (itemSelected)="itemSelected($event)"
        >
        </ldw-structure-list-view>
      </div>
      @if (hasDetail) {
        <div class='split-view-content-detail'>
          <ldw-detail-document-view [documentId]='detailDocumentId' (visibleChanged)='detailVisibleChanged($event)'>
          </ldw-detail-document-view>
        </div>
      }
    </ldw-split-view>
  </div>
}
